import {initMainHeader} from '../js/src/header-init';
import {loadCSS, Utils} from "../js/src/utils";
import WOW from 'wow.js';
import '../scss/pages/configurator.scss';


initMainHeader();
if (window.innerWidth > Utils.screen.sm) {
    loadCSS('build/assets/css/animate.min.css');
    setTimeout(() => (new WOW({offset: 200, live: false, mobile: false})).init(), 200);
}

document.getElementById('scrollBtn').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#supermicro').scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
});


